import { useEffect, useState } from "react";
import api from "@/lib/api";

export const DEFAULT_LOGO = "/motley-logo.jpg";
export const DEFAULT_LOGO_WIDE = "/motley-logo-wide.jpg";
let cache = null;
let inflight = null;

export const fetchSite = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) inflight = api.get("/site").then((r) => { cache = r.data; return cache; }).finally(() => { inflight = null; });
  return inflight;
};

export const invalidateSite = () => { cache = null; };

export const useSite = () => {
  const [site, setSite] = useState(cache);
  useEffect(() => { fetchSite().then(setSite).catch(() => setSite({})); }, []);
  return site || {};
};

export const money = (amount, cur = "INR") => {
  const sym = { INR: "₹", USD: "$", EUR: "€", GBP: "£" }[cur] || `${cur} `;
  return `${sym}${Number(amount || 0).toLocaleString("en-IN")}`;
};

export const fileToDataUrl = (file, maxBytes = 500 * 1024) => new Promise((resolve, reject) => {
  if (!file.type.startsWith("image/")) return reject(new Error("Please choose an image file."));
  if (file.size > maxBytes) return reject(new Error(`Image must be under ${Math.round(maxBytes / 1024)}KB.`));
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(new Error("Could not read file."));
  reader.readAsDataURL(file);
});
